exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\ncanvas[data-v-70845612] {\r\n  -webkit-box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.2), -2px -2px 4px 0 rgba(238, 109, 175, 0.22),\r\n    -2px -2px 4px 0 rgba(238, 109, 175, 0.22);\r\n          box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.2), -2px -2px 4px 0 rgba(238, 109, 175, 0.22),\r\n    -2px -2px 4px 0 rgba(238, 109, 175, 0.22);\r\n  border-radius: 50%;\r\n  /* border:1px solid #000; */\n}\r\n", ""]);

// exports
